export default __webpack_public_path__ + "static/pointred-1f825959d9c2973574eed8751a5690d0.png";